import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import useAuth from 'core/hooks/useAuth';

import Actions from './Actions/Actions';
import AppShell from './AppShell';
import Login from './Auth/Login/Login';
import Logout from './Auth/Logout/Logout';
import PasswordReset from './Auth/PasswordReset/PasswordReset';
import Welcome from './Auth/Welcome/Welcome';
import Customers from './Customers/Customers';
import GuestShell from './GuestShell';
import Maintenances from './Maintenances/Maintenances';
import Products from './Products/Products';
import Services from './Services/Services';
import SurfaceReport from './SurfaceReport/SurfaceReport';
import Surfaces from './Surfaces/Surfaces';
import Users from './Users/Users';
import Vehicles from './Vehicles/Vehicles';

export default function AppRouting() {
  const { authed } = useAuth();

  return (
    <BrowserRouter>
      {authed && (
        <AppShell>
          <Switch>
            <Route path="/surfaces" exact component={Surfaces} />
            <Route path="/reports" exact component={SurfaceReport} />
            <Route path="/maintenances" component={Maintenances} />
            <Route path="/actions" component={Actions} />
            <Route path="/vehicles" component={Vehicles} />
            <Route path="/customers" component={Customers} />
            <Route path="/products" component={Products} />
            <Route path="/services" component={Services} />
            <Route path="/users" component={Users} />
            <Route path="/logout" component={Logout} />
            <Redirect to="/surfaces" />
          </Switch>
        </AppShell>
      )}
      {!authed && (
        <GuestShell>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/password/reset" component={PasswordReset} />
            <Route path="/welcome" component={Welcome} />
            <Redirect to="/login" />
          </Switch>
        </GuestShell>
      )}
    </BrowserRouter>
  );
}
